<div class="campaign-supervisor">
  <!-- Header section with title and action buttons -->
  <header class="supervisor-header">
    <div class="header-content">
      <h1 class="page-title">
        <i class="pi pi-megaphone" aria-hidden="true"></i>
        {{ 'supervisor.campaigns.title' | translate }}
      </h1>
      <p class="header-description">{{ 'supervisor.campaigns.description' | translate }}</p>
    </div>

    <div class="header-actions">
      <button pButton
              type="button"
              icon="pi pi-plus"
              [label]="'supervisor.campaigns.newCampaign' | translate"
              class="p-button-raised"
              (click)="navigateTo('', false, true)">
      </button>
    </div>
  </header>

  <!-- Active campaigns section -->
  <section class="campaign-section" aria-labelledby="active-campaigns">
    <div class="section-header">
      <h2 id="active-campaigns" class="section-title">
        <i class="pi pi-list" aria-hidden="true"></i>
        {{ 'supervisor.campaigns.activeCampaigns' | translate }}
      </h2>
    </div>

    <div class="card campaign-card">
      <p-table [value]="campaigns"
               [paginator]="true"
               [rows]="5"
               [rowsPerPageOptions]="[5,10,20]"
               styleClass="campaign-table"
               [loading]="loading"
               [responsive]="true"
               responsiveLayout="scroll">

        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'supervisor.campaigns.table.name' | translate }}</th>
            <th>{{ 'supervisor.campaigns.table.campaign' | translate }}</th>
            <th>{{ 'supervisor.campaigns.table.type' | translate }}</th>
            <th>{{ 'supervisor.campaigns.table.state' | translate }}</th>
            <th>{{ 'supervisor.campaigns.table.priority' | translate }}</th>
            <th>{{ 'supervisor.campaigns.table.currentAction' | translate }}</th>
            <th>{{ 'supervisor.campaigns.table.actions' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-campaign>
          <tr>
            <td>
              <div class="campaign-name">
                <span class="name-text">{{campaign.name}}</span>
              </div>
            </td>
            <td>{{campaign.campaign_name}}</td>
            <td>
              <span class="campaign-type" [ngClass]="{'type-outbound': campaign.type === 'Outbound', 'type-inbound': campaign.type === 'Inbound'}">
                {{campaign.type}}
              </span>
            </td>
            <td>
              <span class="status-badge" [style.background-color]="getStateColor(campaign.state)">
                {{campaign.state}}
              </span>
            </td>
            <td>
              <div class="priority-indicator">
                <span class="priority-number">{{campaign.priority}}</span>
                <div class="priority-bar" [style.width.%]="(campaign.priority > 100 ? 100 : campaign.priority)"></div>
              </div>
            </td>
            <td>{{campaign.current_action}}</td>
            <td>
              <div class="action-buttons">
                <button pButton
                        type="button"
                        icon="pi pi-eye"
                        class="p-button-text p-button-rounded action-btn"
                        [pTooltip]="'supervisor.campaigns.tooltip.view' | translate"
                        tooltipPosition="top"
                        (click)="navigateTo(campaign.id)">
                </button>
                <button pButton
                        type="button"
                        icon="pi pi-pencil"
                        class="p-button-text p-button-rounded action-btn"
                        [pTooltip]="'supervisor.campaigns.tooltip.edit' | translate"
                        tooltipPosition="top"
                        (click)="navigateTo(campaign.id, true)">
                </button>
                <button pButton
                        type="button"
                        icon="pi pi-users"
                        class="p-button-text p-button-rounded action-btn"
                        [pTooltip]="'supervisor.campaigns.tooltip.manageAgents' | translate"
                        tooltipPosition="top"
                        (click)="showAgentsModal(campaign.id)">
                </button>
                <button pButton
                        type="button"
                        icon="pi pi-trash"
                        class="p-button-text p-button-rounded action-btn delete-btn"
                        [pTooltip]="'supervisor.campaigns.tooltip.delete' | translate"
                        tooltipPosition="top"
                        [disabled]="loading"
                        (click)="confirmDeleteCampaign(campaign)">
                </button>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7">
              <div class="empty-state">
                <i class="pi pi-search" aria-hidden="true"></i>
                <p>{{ 'supervisor.campaigns.empty' | translate }}</p>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="paginatorright">
          <span class="text-muted">{{ 'supervisor.campaigns.paginatorTotal' | translate: { n: campaigns.length || 0 } }}</span>
        </ng-template>
      </p-table>
    </div>
  </section>



  <!-- Agent management dialog -->
  <p-dialog [(visible)]="showAgentsDialog"
            [header]="'supervisor.campaigns.agentDialog.header' | translate"
            [modal]="true"
            [draggable]="false"
            [resizable]="false"
            [style]="{width: '800px'}"
            styleClass="agent-dialog"
            [closeOnEscape]="true"
            [dismissableMask]="true">

    <div class="agent-management">
      <div class="agent-form">
        <h3 class="dialog-subtitle">{{ 'supervisor.campaigns.agentDialog.assignAgent' | translate }}</h3>

        <form [formGroup]="agentAssignForm" class="p-fluid">
          <div class="field">
            <label for="agent">{{ 'supervisor.campaigns.agentDialog.selectAgent' | translate }}</label>
            <p-dropdown id="agent"
                       [options]="agents"
                       formControlName="agent"
                       [placeholder]="'supervisor.campaigns.agentDialog.searchAgent' | translate"
                       optionLabel="username"
                       [showClear]="true"
                       [filter]="true"
                       filterBy="username"
                       appendTo="body">
            </p-dropdown>
          </div>

          <button pButton
                  type="button"
                  icon="pi pi-user-plus"
                  [label]="'supervisor.campaigns.agentDialog.assign' | translate"
                  class="p-button-raised"
                  [disabled]="agentAssignForm.invalid || isDisabledAsign || loading"
                  (click)="assignAgent()">
          </button>
        </form>
      </div>

      <div class="assigned-agents">
        <div class="dialog-subtitle-container">
          <h3 class="dialog-subtitle">{{ 'supervisor.campaigns.agentDialog.assignedAgents' | translate }}</h3>
          <span class="agent-count">{{ 'supervisor.campaigns.agentDialog.agentCount' | translate: { n: assignedAgents.length } }}</span>
        </div>

        <div class="agent-list" *ngIf="assignedAgents.length > 0; else noAgents">
          <div class="agent-item" *ngFor="let agent of assignedAgents">
            <div class="agent-info">
              <div class="agent-avatar">
                <span>{{agent.username.charAt(0) || 'A'}}</span>
              </div>
              <div class="agent-details">
                <h4>{{agent.username}}</h4>
                <p>{{agent.email}}</p>
              </div>
            </div>
            <div class="agent-actions">
              <ng-container *ngIf="campaign_selected?.agent_config?.enable_priority_agent">
                <input type="number"
                       min="{{MIN_DEFAULT_PRIORITY}}"
                       max="{{MAX_DEFAULT_PRIORITY}}"
                       [value]="agentPriorities[agent.email] || {MIN_DEFAULT_PRIORITY}"
                       [disabled]="agentPriorityLoading"
                       class="agent-priority-input"
                       (change)="onAgentPriorityInput(agent.email, $event)"
                       (input)="onAgentPriorityInput(agent.email, $event)"
                       [attr.aria-label]="'supervisor.campaigns.agentDialog.priorityFor' | translate: { name: agent.username }">
              </ng-container>
              <button pButton
                      type="button"
                      icon="pi pi-trash"
                      class="p-button-text p-button-rounded p-button-danger"
                      [pTooltip]="'supervisor.campaigns.tooltip.unassignAgent' | translate"
                      tooltipPosition="top"
                      (click)="deleteassignedAgent(agent.email)">
              </button>
            </div>
          </div>
        </div>

        <!-- Guardar Prioridades button below agent-list, only if enable_priority_agent is true and agents exist -->
        <ng-container *ngIf="campaign_selected?.agent_config?.enable_priority_agent && assignedAgents.length > 0">
          <button pButton
                  type="button"
                  [label]="'supervisor.campaigns.agentDialog.savePriorities' | translate"
                  icon="pi pi-save"
                  class="p-button-success"
                  style="margin-top: 0.5rem;"
                  [disabled]="!agentPriorityChanged || agentPriorityLoading"
                  (click)="saveAgentPriorities()">
          </button>
          <span *ngIf="agentPriorityLoading" class="ml-2"><i class="pi pi-spin pi-spinner"></i> {{ 'supervisor.campaigns.agentDialog.saving' | translate }}</span>
        </ng-container>

        <ng-template #noAgents>
          <div class="empty-agents">
            <i class="pi pi-users" aria-hidden="true"></i>
            <p>{{ 'supervisor.campaigns.agentDialog.noAgents' | translate }}</p>
            <small>{{ 'supervisor.campaigns.agentDialog.noAgentsHint' | translate }}</small>
          </div>
        </ng-template>
      </div>
    </div>
  </p-dialog>

  <!-- Toast and confirmation components -->
  <p-toast position="top-right"></p-toast>

  <!-- Campaign Delete Confirmation Dialog -->
  <p-confirmDialog
    key="campaignDelete"
    [header]="'supervisor.campaigns.deleteDialog.header' | translate"
    icon="pi pi-exclamation-triangle"
    [style]="{width: '500px', maxWidth: '90vw'}"
    [baseZIndex]="10000"
    rejectButtonStyleClass="p-button-text p-button-secondary confirm-cancel-btn"
    acceptButtonStyleClass="p-button-danger confirm-delete-btn"
    [closable]="!loading"
    [closeOnEscape]="!loading"
    [dismissableMask]="!loading"
    [acceptLabel]="'supervisor.campaigns.deleteDialog.accept' | translate"
    [rejectLabel]="'supervisor.campaigns.common.cancel' | translate"
    styleClass="campaign-delete-dialog"
    role="alertdialog">
  </p-confirmDialog>

  <!-- Agent Remove Confirmation Dialog -->
  <p-confirmDialog
    key="agentRemove"
    [header]="'supervisor.campaigns.removeAgentDialog.header' | translate"
    icon="pi pi-exclamation-triangle"
    [style]="{width: '500px', maxWidth: '90vw'}"
    [baseZIndex]="10000"
    rejectButtonStyleClass="p-button-text p-button-secondary confirm-cancel-btn"
    acceptButtonStyleClass="p-button-warning confirm-remove-btn"
    [closable]="!loading"
    [closeOnEscape]="!loading"
    [dismissableMask]="!loading"
    [acceptLabel]="'supervisor.campaigns.removeAgentDialog.accept' | translate"
    [rejectLabel]="'supervisor.campaigns.common.cancel' | translate"
    styleClass="agent-remove-dialog"
    role="alertdialog">
  </p-confirmDialog>
</div>
